// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  configpath: './assets/_conf/',
  name: 'prod',

  //url: "http://localhost:4200"
  url: "https://optimasmart-api.ar4mdigital.it"
  //url: "https://optimasmart-test-api.ar4mdigital.it"
};